import type { FC } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@onshopfront/components";
import { useDeveloperDispatch, useDeveloperSelector } from "../../_Bootstrap/hooks.ts";
import { logoutUser } from "../../Actions/UserActions";

export const User: FC = () => {
    const user = useDeveloperSelector(selector => selector.user.user);
    const dispatch = useDeveloperDispatch();

    const onLogout = (): void => {
        dispatch(logoutUser());
    };

    if(user === false) {
        return (
            <>
                <Link
                    to="/register"
                    className="block flex-1 text-right text-white no-underline hover:underline ml-4"
                >
                    <Icon
                        icon={[ "fal", "user-plus" ]}
                        className="mr-2"
                    />
                    Register
                </Link>
                <Link
                    to="/login"
                    className="block text-white no-underline hover:underline"
                >
                    <Icon
                        icon={[ "fal", "sign-in" ]}
                        className="mr-2"
                    />
                    Log In
                </Link>
            </>
        );
    }

    return (
        <>
            <Link
                to="/account"
                className="block flex-1 text-right truncate text-white no-underline hover:underline ml-6"
            >
                <Icon
                    icon={[ "fal", "user" ]}
                    className="mr-2"
                />
                {user.name}
            </Link>
            <button
                onClick={onLogout}
                className="cursor-pointer bg-transparent text-base text-white no-underline hover:underline"
            >
                <Icon
                    icon={[ "fal", "sign-out" ]}
                    className="mr-2"
                />
                Sign Out
            </button>
        </>
    );
};
